var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c("Subheader", {
        attrs: { title: "Stations", search: "locations" },
        scopedSlots: _vm._u(
          [
            {
              key: "title",
              fn: function () {
                return [
                  _c(
                    "v-toolbar-title",
                    { staticStyle: { width: "270px" } },
                    [
                      _c("v-icon", { attrs: { medium: "" } }, [
                        _vm._v("router"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "headline" }, [
                        _vm._v(_vm._s(_vm.title)),
                      ]),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            _vm.supportsRefresh
              ? {
                  key: "actions",
                  fn: function () {
                    return [
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "", loading: _vm.loading },
                          on: { click: _vm.refresh },
                        },
                        [_c("v-icon", [_vm._v("refresh")])],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
        model: {
          value: _vm.search,
          callback: function ($$v) {
            _vm.search = $$v
          },
          expression: "search",
        },
      }),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          "hide-headers": "",
          items: _vm.monitoringFeatures,
          headers: _vm.headers,
          search: _vm.search,
          pagination: _vm.pagination,
          "item-key": "DisplayName",
          loading: _vm.loading,
        },
        on: {
          "update:pagination": function ($event) {
            _vm.pagination = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function ({ item }) {
              return [
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(_vm._s(_vm.getDisplayName(item))),
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-right" },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          depressed: "",
                          small: "",
                          to: {
                            name: "monitoringfeature",
                            params: { monitoringFeatureId: item.Id },
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "text-capitalize" }, [
                          _vm._v("View"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }